/* import __COLOCATED_TEMPLATE__ from './pronunciation-manager.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Store from '@ember-data/store';
import type FinVoicePronunciation from 'embercom/models/fin-voice/pronunciation';

interface Signature {
  Args: {};
  Element: HTMLElement;
}

export default class PronunciationManager extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare notificationsService: $TSFixMe;
  @service declare store: Store;

  @tracked pronunciations: FinVoicePronunciation[] = [];
  @tracked isLoading = false;

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    this.loadPronunciations();
  }

  async loadPronunciations() {
    try {
      this.isLoading = true;
      let models = await this.store.findAll('fin-voice/pronunciation');
      this.pronunciations = models.slice();
    } catch (_e: unknown) {
      this.notificationsService.notifyError(
        this.intl.t('ai-agent.voice-playground.pronunciation-manager.load-error'),
      );
    } finally {
      this.isLoading = false;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::PronunciationManager': typeof PronunciationManager;
    'ai-agent/voice-playground/pronunciation-manager': typeof PronunciationManager;
  }
}
